import { render } from "./BuyModal.vue?vue&type=template&id=07397892&scoped=true&ts=true"
import script from "./BuyModal.vue?vue&type=script&lang=ts"
export * from "./BuyModal.vue?vue&type=script&lang=ts"

import "./BuyModal.vue?vue&type=style&index=0&id=07397892&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07397892"]])

export default __exports__